// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__Lg1bl","range":"MonthRangeSwitch_range__17c54","disabled":"MonthRangeSwitch_disabled__yKSr6"};